import React, { useState, useEffect } from "react";
import { useForm } from "../../../hooks/useForm";
import { Cargando } from "../../Otros/Cargando";
import { Funcionarios } from "../../Otros/Funcionarios";
import Swal from "sweetalert2";
import { Placeholder } from "semantic-ui-react";
import { PlaceholderColumnas } from "../../Otros/Placeholder";
import { UrlWs } from "../../../utils/Global";
import { Precalificadores } from "../../Otros/Precalificadores";

async function actualizarJunta(payload) {
  const url =UrlWs+
    "/qualifyingBoard";
  const response = await fetch(url, {
    method: "PUT",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    return response.status == 200;
  });
  return response;
}

const _SelectFuncionarios = ({ nombreCampo, updateValue, nuevoValue }) => {
  return (
    <Funcionarios
      nombreCampo={nombreCampo}
      updateValue={updateValue}
      nuevoValue={nuevoValue}
    />
  );
};

/**FUNCIONARIOS CON FEA */
const SelectFuncionarios =({ nombreCampo, updateValue, nuevoValue }) => {
  return (
  
    <Precalificadores
      nombreCampo={nombreCampo}
      updateValue={updateValue}
      nuevoValue={nuevoValue}
    />
  );
};


export const ActualizarJuntaCalificadora = ({ idProcess, qualifyingBoard }) => {
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [actualizandoDatos, setActualizandoDatos] = useState(false);
  const [
    valoresFormulario,
    handleInputChange,
    reset,
    updateValue,
    updateState,
  ] = useForm({
    presidente: null,
    representante: null,
    integrante1: null,
    integrante2: null,
    secretario: null,
    presidente_asociacion: null,
  });

  const {
    presidente,
    representante,
    integrante1,
    integrante2,
    secretario,
    presidente_asociacion,
  } = valoresFormulario;

  const handleClick = () => {
    setActualizandoDatos(true);
    const payload = {
      id_process: idProcess,
      presidentJC: presidente,
      secretaryJC: secretario,
      representativeFuncJC: representante,
      memberUnoJC: integrante1,
      memberDosJC: integrante2,
      presidentAsoccFuncJC: presidente_asociacion,
    };
    actualizarJunta(payload).then((respuesta) => {
      if (respuesta) {
        Swal.fire({
          title: "Listo",
          text: "Junta calificadora actualizada correctamente",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Ocurrió un error al actualizar la Junta Calificadora",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
      setActualizandoDatos(false);
    });
    return;
  };

  useEffect(() => {
    console.log("Process actualizar JC");
    console.log(typeof qualifyingBoard);
    console.log(qualifyingBoard);
    console.log(typeof idProcess);
    console.log(idProcess);
    if (qualifyingBoard != null) {
      const _qualifyingBoard = qualifyingBoard;
      updateState([
        { name: "presidente", value: _qualifyingBoard.presidentJC },
        {
          name: "representante",
          value: _qualifyingBoard.representativeFuncJC,
        },
        { name: "integrante1", value: _qualifyingBoard.memberUnoJC },
        { name: "integrante2", value: _qualifyingBoard.memberDosJC },
        { name: "secretario", value: _qualifyingBoard.secretaryJC },
        {
          name: "presidente_asociacion",
          value: _qualifyingBoard.presidentAsoccFuncJC,
        },
      ]);
    }
  }, [qualifyingBoard]);

  return (
    <> 
      <div className="modal fade" id="m-acCalificadora" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered mw-900px">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Actualizar junta Calificadora</h2>
              <div
                className="btn btn-sm btn-icon btn-active-color-primary"
                data-bs-dismiss="modal"
              >
                <span className="svg-icon svg-icon-1">X</span>
              </div>
            </div>
            <div className="modal-body py-lg-10 px-lg-10">
              <div className="row">
                {cargandoDatos ? (
                  <PlaceholderColumnas
                    columnas={2}
                    filas={3}
                  ></PlaceholderColumnas>
                ) : (
                  <>
                    <div className="col-md-6">
                      <div className="mb-10">
                        <label htmlFor="" className="form-label">
                          Presidente:
                        </label>
                        <SelectFuncionarios
                          nombreCampo="presidente"
                          updateValue={updateValue}
                          nuevoValue={presidente}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-10">
                        <label htmlFor="" className="form-label">
                          Secretario:
                        </label>
                        <SelectFuncionarios
                          nombreCampo="secretario"
                          updateValue={updateValue}
                          nuevoValue={secretario}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-10">
                        <label htmlFor="" className="form-label">
                          Representante:
                        </label>
                        <SelectFuncionarios
                          nombreCampo="representante"
                          updateValue={updateValue}
                          nuevoValue={representante}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-10">
                        <label htmlFor="" className="form-label">
                          Integrante 1:
                        </label>
                        <SelectFuncionarios
                          nombreCampo="integrante1"
                          updateValue={updateValue}
                          nuevoValue={integrante1}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-10">
                        <label htmlFor="" className="form-label">
                          Integrante 2:
                        </label>
                        <SelectFuncionarios
                          nombreCampo="integrante2"
                          updateValue={updateValue}
                          nuevoValue={integrante2}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-10">
                        <label htmlFor="Asociación" className="form-label">
                          Pdt. Asociación:
                        </label>
                        <SelectFuncionarios
                          nombreCampo="presidente_asociacion"
                          updateValue={updateValue}
                          nuevoValue={presidente_asociacion}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="d-flex justify-content-end">
                <button
                  disabled={actualizandoDatos}
                  type="button"
                  className="btn btn-sm btn-success"
                  onClick={handleClick}
                >
                  {actualizandoDatos
                    ? " Actualizando datos..."
                    : " Actualizar"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
